exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.amount[data-v-6854e843]{font-weight:bold\n}\n", ""]);

// exports
